import { post } from "@/api/http";
import store from "@/store/index";
import { clearAreaPhoneCode } from "@/api/user";
import { apiHttp } from "@/api/index";

export const userLoginByPassword = (username: string, password: string) => {
  const formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);
  formData.append("platform", "1");
  return post("/sys/user/login", formData);
};

export const userLoginByCode = async (value: string, code: number) => {
  const formData = new FormData();

  formData.append("mobileOrEmail", value);
  formData.append("code", String(code));
  formData.append("platform", "1");
  try {
    const res: any = await apiHttp.post("/sys/user/check-code-login", formData);

    return Promise.resolve({
      success: Boolean(res.tokenValue),
      data: res,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

export const createUser = async (data = {}) => {
  try {
    const res: any = await apiHttp.post(
      "/sys/user/create-user-signtrust",
      data
    );

    return Promise.resolve({
      isSuccess: res === true,
    });
  } catch (error) {
    return Promise.resolve({
      isSuccess: false,
    });
  }
};

export const checkSmsCode = async (
  phone: string,
  code: string,
  areaCode: string
) => {
  const formData = new FormData();

  formData.append("mobileOrEmail", phone);
  formData.append("code", code);
  formData.append("areaCode", clearAreaPhoneCode(areaCode));
  try {
    const res: any = await apiHttp.post("/sys/user/check-code", formData);
    return Promise.resolve<any>({
      success: res === true,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

export const checkEmailCode = async (usrEmail: string, code: string) => {
  const formData = new FormData();

  formData.append("mobileOrEmail", usrEmail);
  formData.append("code", code);
  try {
    const res: any = await apiHttp.post("/sys/user/check-code", formData);
    return Promise.resolve<any>({
      success: res === true,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

export const sentSmsCode = (phone: string, areaCode: string) =>
  post("/signtrustv3/usr/GetSmsCode", {
    areaCode: clearAreaPhoneCode(areaCode),
    phone,
    sofId: store.getters.sofId,
  });

export const sentEmailOrPhoneCode = async (value: string) => {
  const formData = new FormData();

  formData.append("mobileOrEmail", value);
  formData.append("platform", "1");
  try {
    const res: any = await apiHttp.post("/sys/user/send-code", formData);
    return Promise.resolve<any>({
      success: res === true,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

export const loginUserSelectCompany = (data: {
  coId: string;
  usrId: number;
  sofId: string;
}) =>
  post("/signtrustv3/usr/CheckCoSof", {
    clientplatformId: 0,
    coId: data.coId,
    usrId: data.usrId,
    sofId: data.sofId,
  });

export const checkTenantExpireTimeAndStatus = async (tenantId: any) => {
  try {
    return Promise.resolve(
      await apiHttp.get(
        `/sys/tenant/check-tenant-expire-time-and-status/${tenantId}`
      )
    );
  } catch (error) {
    return Promise.reject(false);
  }
};

export const getCompanyList = async () => {
  try {
    const res = await apiHttp.get("/ums/company/list/sigtrust");

    return Promise.resolve(Array.isArray(res) ? res : []);
  } catch (error) {
    return Promise.resolve([]);
  }
};

export const checkIpAccess = async () => {
  try {
    return Promise.resolve(
      await apiHttp.post("/ums/tenant-user/check-ip-access-restrictions")
    );
  } catch (error) {
    return Promise.resolve(false);
  }
};
